{
  "common" : {
    "show" : "Visa",
    "about" : "Om",
    "newPost" : "Nytt inlägg",
    "active" : "Aktiv",
    "change" : "Ändra",
    "remove" : "Ta bort",
    "cancel" : "Avbryt",
    "publish" : "Publicera",
    "save" : "Spara",
    "draft" : "Utkast",
    "scheduled" : "Schemalagd",
    "published" : "Publicerad",
    "actions" : "Åtgärder",
    "archive" : "Arkivera",
    "delete" : "Radera",
    "edit" : "Redigera",
    "edited" : "Redigerad",
    "settings" : "Inställningar",
    "updatedOn" : "Uppdaterad den",
    "blogPost" : "Blogginlägg",
    "category" : "Kategori",
    "author" : "Författare",
    "status" : "Status",
    "errors" : "Fel",
    "all" : "Alla",
    "archived" : " Arkiverad",
    "back" : "Tillbaka",
    "restore" : "Återställ den här versionen",
    "next" : "Nästa",
    "previous" : "Föregående",
    "continue" : "Fortsätt",
    "paid" : "Betald",
    "free" : "Gratis",
    "uploadImagesVideos" : "Ladda upp bilder/videor",
    "upload" : "Ladda upp",
    "add" : "Lägg till",
    "to" : "till",
    "on" : "På",
    "from" : "från",
    "members" : "Medlemmar",
    "visibility" : "Synlighet",
    "private" : "Privat",
    "public" : "Offentlig",
    "description" : "Beskrivning",
    "managedBy" : "Hanteras av",
    "noManagers" : "Inga chefer",
    "noDescription" : "Ingen beskrivning",
    "more" : "Mer",
    "moreCaps" : "Mer",
    "less" : "mindre",
    "and" : "och",
    "in" : "in",
    "allSet" : "Allt är klart!",
    "createdBy" : "Skapad av",
    "home" : "Hem",
    "selected" : "Vald",
    "groupMembers" : "Gruppens medlemmar",
    "everyone" : "Alla",
    "manager" : "Ansvarig",
    "leave" : "Lämna",
    "membersList" : "Medlemslista",
    "findChannelManagers" : "Hitta kanalansvariga",
    "searchGroupMembers" : "Sök efter gruppmedlemmar",
    "searchMembers" : "Sök efter medlemmar",
    "searchMember" : "Sök efter medlem",
    "enterDescription" : "Ange beskrivning",
    "apply" : "Tillämpa",
    "selectRole" : "Välj roll",
    "people" : "Personer",
    "viewProfile" : "Visa profil",
    "leaderboard" : "Topplista",
    "events" : "Händelser",
    "logOut" : "Logga ut",
    "share" : "Dela",
    "copyLink" : "Kopiera länk",
    "reply" : "Svara",
    "download" : "Ladda ner",
    "noPreviewAvailable" : "Ingen förhandsgranskning tillgänglig",
    "userNotFound" : "Användaren hittades inte",
    "unableToPreviewPdf" : "För närvarande går det inte att förhandsgranska PDF-filen. Ladda ner den för att visa.",
    "failedToDownloadPdf" : "Misslyckades att ladda ner PDF-filen",
    "notifyAll" : "Meddela alla i kanalen",
    "communities" : "Communities",
    "courses" : "Kurser",
    "affiliates" : "Partners",
    "chats" : "Chatt",
    "switchToDarkMode" : "Byt till mörkt läge",
    "switchToLightMode" : "Byt till ljust läge",
    "editProfile" : "Redigera profil",
    "account" : "Konto",
    "logout" : "Logga ut",
    "noResults" : "Inga resultat",
    "confirmPayment" : "Bekräfta betalning",
    "done" : "Klar",
    "manage" : "HANTERA",
    "copied" : "Kopierad",
    "submit" : "Skicka",
    "request" : "Förfrågan",
    "approve" : "Godkänn",
    "decline" : "Avböj",
    "comingSoon" : "Kommer snart",
    "detailsUpdatedSuccessfully" : "Informationen har uppdaterats",
    "oopsUnableToSaveDetails" : "Hoppsan! Det gick inte att spara informationen.",
    "verificationFailedPleaseTryAgain" : "Verifieringen misslyckades! Försök igen",
    "loading" : "Läser in",
    "title" : "Titel",
    "addLink" : "Lägg till länk",
    "writeHere" : "Skriv här",
    "copy" : "Kopiera",
    "register" : "Registrera dig",
    "registered" : "Registrerad",
    "search" : "Sök",
    "confirm" : "Bekräfta",
    "success" : "Framgång",
    "toReview" : "Att Recension",
    "invite" : "Bjud in",
    "contributions" : "Bidrag",
    "communitiesSettings" : "Inställningar för communityn",
    "create" : "Skapa",
    "name" : "Namn",
    "linkCopied" : "Länk Kopierad!",
    "move" : "Flytta",
    "irreversible" : "irreversibel",
    "close" : "Stäng",
    "greeting" : "Hej {name}!",
    "managePayments" : "Hantera betalningar",
    "manageYourAccount" : "Hantera ditt Konto",
    "accountSettings" : "Konto Inställningar",
    "proceed" : "Fortsätt",
    "uploading" : "Laddar upp",
    "retry" : "Försök igen",
    "login" : "Logga in",
    "follow" : "Följ",
    "following" : "Följer",
    "followers" : "Följare",
    "view" : "VISA",
    "channels" : "Kanaler",
    "somethingWentWrong" : "Något gick fel. Försök igen.",
    "noFollowersTitle" : "Det verkar som att ingen följer dig.",
    "noFollowersSubtext" : "Lägg till din kontakt i följarlistan",
    "noFollowingTitle" : "Du följer ingen än.",
    "noFollowingSubtext" : "Börja följa personer för att se deras inlägg",
    "followBack" : "Följ tillbaka",
    "logIn" : "LOGGA IN",
    "video" : "Video",
    "audio" : "Audio"
  },
  "imageUpload" : {
    "cropYourAvatar" : "Beskär din avatar",
    "dragToReposition" : "Dra för att flytta"
  },
  "mediaUpload" : {
    "uploadVideo" : "Ladda upp video",
    "addVideoUsingLink" : "Lägg till video via länk"
  },
  "mandatedInfoModal" : {
    "completeYourProfile" : "Slutför din profil",
    "profileIntentMessage1" : "Communities känns konstiga utan ansikten och namn.",
    "profileIntentMessage2" : "Profiler inger förtroende och skapar kontakt med andra",
    "complete" : "SLUTFÖR",
    "recommendedAspectRatio" : "Ladda upp en {types}. Rekommenderad Utseende Procentsats 1:1",
    "addBio" : "Lägg till en biografi … (valfritt)"
  },
  "validations" : {
    "nameRequired" : "Namn krävs!",
    "invalidDescription" : "Ogiltig beskrivning!"
  },
  "payment" : {
    "recurringWithTrial" : "Du kommer att debiteras {price} {currencySymbol} per {interval} efter att provperioden är slut. Du kan avbryta när som helst.",
    "recurring" : "{price} {currencySymbol} per {interval} med möjlighet att avbryta när som helst.",
    "oneTime" : "{price} {currencySymbol} {paymentText}",
    "defaultOneTimeText" : "engångspris för abonnemang.",
    "totalAmount" : "Totalt belopp",
    "trialDays" : "{days} dagars provperiod",
    "securePayments" : "100 % säkra och trygga betalningar",
    "allowToChargeCard" : "Genom att ange dina kortuppgifter tillåter du att {locationName} drar framtida betalningar från kortet i enlighet med deras villkor.",
    "paymentSuccessful" : "Betalningen lyckades!"
  },
  "channel" : {
    "notifications" : {
      "managersEdited" : "Chefer redigerades!",
      "managersAdded" : "Chefer har lagts till framgångsrikt!",
      "managersAddedToChannel" : "chefer som lagts till i",
      "memberPostingEnabled" : {
        "title" : "Uppdaterad Medlemmars inlägg har genomförts",
        "content" : "Medlemmars inlägg har varit Aktiverad"
      },
      "memberPostingDisabled" : {
        "title" : "Uppdaterad Medlemmars inlägg har genomförts",
        "content" : "Medlemmars inlägg har blivit Inaktiverad"
      },
      "created" : {
        "title" : "Ny kanal skapad",
        "content" : ""
      },
      "updated" : {
        "title" : "Uppdaterade kanalinställningar",
        "content" : ""
      },
      "deleted" : {
        "title" : "Kanal raderad",
        "content" : ""
      },
      "error" : {
        "createFailed" : {
          "title" : "Misslyckades att skapa kanal",
          "content" : "Försök igen senare"
        },
        "updateFailed" : {
          "title" : "Misslyckades att uppdatera kanal",
          "content" : "Försök igen senare"
        },
        "managersEditedFailed" : {
          "title" : "Uppdatering av chefer misslyckades!",
          "content" : ""
        },
        "addFailed" : {
          "title" : "Det gick inte att lägga till chefer!",
          "content" : ""
        }
      }
    },
    "createChannel" : "Skapa KANAL",
    "updateChannel" : "UPPDATERA KANALEN",
    "addMembers" : "Lägg till medlemmar",
    "addManagers" : "Lägg till chefer",
    "typeToAddMoreMembers" : "Skriv för att lägga till fler medlemmar",
    "examplePlaceholder" : "ex. John eller Jane",
    "makeChannelManager" : "Gör till kanalansvarig",
    "removeFromChannelManager" : "Ta bort som kanalansvarig",
    "manager" : "Ansvarig",
    "channelManager" : "Kanalansvarig",
    "noMembersFound" : "Inga medlemmar hittades.",
    "noManagersFound" : "Inga ansvariga hittades.",
    "removeChannelMember" : "Ta bort kanalmedlem",
    "removeConfirmationMessage" : "Är du säker på att du vill ta bort",
    "makeManagerConfirmationMessage" : "Är du säker på att du vill göra",
    "makeManagerConfirmationMessage2" : "till kanalansvarig i",
    "channelName" : "Kanalens namn",
    "channelIcon" : "Kanalikon",
    "addChannel" : "Lägg till kanal",
    "editChannel" : "Redigera Kanal",
    "announcementChannel" : "MEDDELANDE Kanal",
    "noChannelsAvailable" : "Inga kanaler tillgängliga",
    "makeChannelPrivate" : "Gör kanalen privat",
    "makeChannelPrivateMessage" : "Begränsa medlemmens åtkomst till alla kanaldiskussioner och interaktioner.",
    "readOnlyChannel" : "Läs Kanal",
    "readOnlyChannelMessage" : "Medlemmar kan Visa VIKTIGT information och uppdateringar, men endast administratörer/ägare av kanalen kan Story här.",
    "createPrivateChannel" : "Skapa den här Kanal Privat",
    "createPrivateChannelMessage" : "Endast inbjudna Medlemmar . Icke-medlemmar kommer inte att se denna Yta",
    "allowMembersToPost" : "Aktivera Medlemmar till Story",
    "allowMembersToPostMessage" : "Aktivera det här alternativet Aktivera Medlemmar för att skapa inlägg och feedback",
    "enableMemberPostingConfirmation" : {
      "mainMessage" : "Om du aktiverar Medlemmar-inlägg kommer Aktivera varje Medlemmar till Skapa och Dela att göra inlägg i kanalen.",
      "mainMessage2" : "Se till att varje Medlemmar är medveten om Ny posting Behörigheter.",
      "pointer1" : "Denna Åtgärd kan återkallas vid vilket datum som helst.",
      "pointer2" : "Varje inlägg Skapad av Medlemmar kommer att vara synlig för Alla in kanalen."
    },
    "privateChannelTooltip" : "Du har inte åtkomst till den här kanalen",
    "restrictMembersFromPosting" : "Begränsa Medlemmar Från-inlägg",
    "restrictMembersFromPostingMessage" : "Inaktivera alternativet förhindrar att Medlemmar Från det här skapade Eller redigerar inlägg och feedback inom kanalen.",
    "disableMemberPostingConfirmation" : {
      "mainMessage" : "Inaktivera Medlemmars inlägg begränsar varje Medlemmar Från skapad och delning av inlägg inom kanalen.",
      "mainMessage2" : "Se till att alla medlemmar är medvetna om begränsningarna för Nya inlägg.",
      "pointer1" : "Denna Åtgärd kan återkallas vid vilket datum som helst.",
      "pointer2" : "Varje inlägg skapad av Medlemmar Före denna Ändra kommer att förbli synlig för Alla in kanalen."
    },
    "deleteChannel" : "Radera kanal",
    "deleteChannelMessage" : "Om du raderar kanalen förloras alla tillhörande data permanent.",
    "deleteChannelMessageWithCourse" : "Om du Raderar kanalen förloras Medlemmar-data permanent och alla kurser som är länkade till den här kanalen blir Offentliga om du inte raderar dem först.",
    "editChannelName" : "Redigera kanalens namn",
    "editChannelDescription" : "Redigera kanalens beskrivning",
    "channelNamePlaceholder" : "t.ex. Marknadsföringsrapporter",
    "editManagers" : "Redigera chefer",
    "channelManagers" : "Kanalansvariga",
    "leaveChannel" : "Lämna kanal",
    "leaveChannelConfirmation" : "Är du säker på att du vill lämna den här kanalen?",
    "changeToPrivateChannel" : "Gör kanalen privat",
    "changeToPrivateChannelMessage" : "Om du gör kanalen privat begränsas användningen av kanalen så att bara medlemmar kan delta i interaktioner och diskussioner.",
    "changeToPrivateChannelConfirmation" : {
      "mainMessage" : "Om du byter den här kanalen till Privat kommer GRÄNS Åtkomst endast till Markerad Medlemmar och chefer.",
      "mainMessage2" : "Kom ihåg att inkludera varje önskad Medlemmar till din privata kanal.",
      "pointer1" : "Den här Åtgärd är",
      "pointer2" : "Ny Medlemmar läggs till i kanalen kommer att ha Åtkomst till varje TIDIGARE-diskussioner och interaktioner inom kanalen."
    },
    "changeToPublicChannel" : "Gör kanalen offentlig",
    "changeToPublicChannelMessage" : "Om du gör Kanalen Offentlig kommer det att Aktivera alla Grupp Medlemmar att Visa och gå med i denna Kanal.",
    "changeToPublicChannelConfirmation" : {
      "mainMessage" : "Genom att ändra den här kanalen till offentlig kommer den att bli tillgänglig för alla gruppmedlemmar.",
      "mainMessage2" : "Alla Grupp Medlemmar kommer att kunna Visa och gå med i denna Kanal.",
      "pointer1" : "Alla medlemmar i gruppen kommer automatiskt att få logga in till denna kanal.",
      "pointer2" : "TIDIGARE Privat Kanal Media kommer att bli synligt för Alla Grupp Medlemmar."
    },
    "publicChannel" : "Offentlig kanal",
    "peopleWhoCanManage" : "Människor som kan hantera",
    "addChannelHelperText" : "Visa mer community: Lägg till kanaler för olika diskussioner, Duet och anslutning.",
    "privateChannel" : "Privat kanal"
  },
  "chat" : {
    "unblockUser" : "Avblockera användare",
    "blockUser" : "Blockera användare",
    "blockMessage1" : "Du kommer inte längre att kunna skicka meddelanden till den här användaren.",
    "blockMessage2" : "Detta konto kommer inte att blockeras i gruppen. Du kanske fortfarande kan se personens inlägg, kommentarer och reaktioner.",
    "deleteChat" : "Radera chatt",
    "deleteChatMessage" : "Är du säker på att du vill radera den här konversationen?",
    "block" : "Block",
    "conversation" : "konversation",
    "messageNotSent" : "Detta meddelande skickades inte",
    "sending" : "Skickar",
    "youAndUserKnowEachOther" : "Du och {name} känner varandra",
    "startConversationWithHi" : "Starta en konversation genom att skriva ”Hej”",
    "accountSettings" : "Kontoinställningar",
    "blockedUserMessage" : "Du har blockerat { name }. Ni kan inte skicka eller ta emot meddelanden. Avblockera hen för att starta en konversation. För att granska din lista över blockerade användare, besök din",
    "blockRecipientMessage" : "{ name } har blockerat dig. Du kan inte skicka eller ta emot meddelanden.",
    "nothingFound" : "Ingenting hittades!",
    "pleaseCheckUsername" : "Kontrollera användarnamnet och försök igen",
    "startChatting" : "Börja chatta",
    "noChatYet" : "Det verkar som att du inte har chattat med någon än.",
    "noChatYetMessage" : "Sök efter en kontakt och ta första steget!",
    "noConversationsFound" : "Inga konversationer hittades",
    "searchMembersAndStartChatting" : "Sök efter medlemmar och börja chatta",
    "cannotMessageDeletedUser" : "Du kan inte ladda upp meddelanden till en Raderad Användare",
    "message" : "Meddelande",
    "media" : "Media",
    "files" : "Filer"
  },
  "comments" : {
    "reportComment" : "Rapportera kommentar",
    "reportCommentMessage" : "Är du säker på att du vill rapportera den här kommentaren?",
    "deleteComment" : "Radera kommentar",
    "editComment" : "Redigera kommentar",
    "loadMoreReplies" : "Ladda fler svar",
    "deleteCommentMessage" : "Är du säker på att du vill radera den här kommentaren?",
    "writeComment" : "Skriv en kommentar",
    "comment" : "KOMMENTAR",
    "cancel" : "AVBRYT",
    "save" : "SPARA",
    "replyingTo" : "Svarar på",
    "newComment" : "Ny kommentar",
    "latest" : "Senaste",
    "onlyAdminsCanComment" : "Endast community kan kommentera in den här kanalen.",
    "isCommentDisabledForPost" : "Feedback är Inaktiverad för det här Dela.",
    "isCommentDisabledErrorContent" : "feedback har inaktiverad med denna delning Via redigeraren Eller Grupp Admin.",
    "isCommentDisabledErrorTitle" : "Feedback inaktiverad"
  },
  "embeds" : {
    "uploadImage" : "Ladda upp foto",
    "addYoutubeVimeoLoomLink" : "Lägg till en länk till Youtube, Vimeo eller Loom",
    "uploadAttachment" : "Ladda upp PDF-, CSV- eller XLSX-filer",
    "addAttachment" : "Lägg till bilaga",
    "allowedTypes" : "SVG, PNG, JPG eller GIF (max 800x400 px)",
    "placeholder" : "Lägg till en länk till Youtube, Vimeo eller Loom",
    "uploadVideo" : "Ladda upp/länka video",
    "uploadVideoPlaceholder" : "Lägg till en länk till Youtube, Vimeo eller Loom",
    "uploadVideoAllowedTypes" : "Ladda upp en MP4 video-fil",
    "addEmoji" : "Lägg till emoji",
    "emojiSuggestion" : "Öppnar Emoji-väljaren",
    "addGif" : "Lägg till GIF",
    "gifSuggestion" : "Öppnar GIF-väljaren",
    "addImage" : "Lägg till foto",
    "imageSuggestion" : "Öppnar ditt galleri",
    "addVideo" : "Lägg till video",
    "videoSuggestion" : "Öppnar ditt galleri",
    "selectFile" : "Välj fil",
    "attachmentSuggestion" : "Öppnar filhanteraren",
    "takePhoto" : "Ta foto",
    "uploadPhotoVideo" : "Ladda upp foto/video",
    "limitExceeded" : "Gränsen har överskridits",
    "limitExceededMessage" : "Du kan inte bifoga fler än 4 filer",
    "errorWhileUploadingFile" : "Fel vid uppladdning av filen! Försök igen",
    "clickToUpload" : "Klicka för att ladda upp",
    "orDragAndDrop" : "eller dra och släpp",
    "validUrl" : "En giltig webbadress krävs",
    "enterSomeText" : "Skriv lite brödtext",
    "addLink" : "Lägg till länk",
    "text" : "Text",
    "addVideoLink" : "Eller, Inkludera a YouTube, Vimeo, Loom, Eller Wistia Video Länk.",
    "uploadVideoAndImages" : "Ladda upp videor och bilder",
    "recommendedAspectRatio" : "Rekommenderad Utseende Procentsats {ratio}",
    "addHashtag" : "Etikett kanaler, instanser och kurser"
  },
  "tabSwitcher" : {
    "discussion" : "Diskussion",
    "learning" : "Utbildning",
    "members" : "Medlemmar",
    "leaderboard" : "Topplista",
    "channels" : "Kanaler",
    "groups" : "Grupper",
    "more" : "Mer",
    "home" : "Hem",
    "discover" : "Upptäck",
    "courses" : "Kurser",
    "communities" : "Communities"
  },
  "groupInfo" : {
    "pinGroup" : "Fäst Grupp",
    "unpinGroup" : "Lossa Grupp",
    "maxPinnedGroupsLimit" : "Endast upp till 4 Grupp kan fästas",
    "publicGroup" : "Offentlig grupp",
    "privateGroup" : "Privat grupp",
    "members" : "Medlemmar",
    "posts" : "Inlägg",
    "admin" : "Admin",
    "settings" : "INSTÄLLNINGAR",
    "inviteMembers" : "BJUD IN MEDLEMMAR",
    "answerQuestions" : "Svara på frågor",
    "toJoin" : "att gå med i {name}",
    "changeRole" : "Ändra roll",
    "removeFromGroup" : "Ta bort från gruppen",
    "contributor" : "Bidragsgivare",
    "membershipAnswers" : "Svar om medlemskap",
    "unbanMember" : "Ta bort avstängning för medlem",
    "banFromGroup" : "Avstängd från grupp",
    "requestedOn" : "Efterfrågad den",
    "invitedOn" : "Inbjuden den",
    "joinedOn" : "Gick med",
    "noMembersFound" : "Inga medlemmar hittades.",
    "youAreAllCaughtUp" : "Du're varje catched up—no Medlemmar här Höger nu!",
    "banUserConfirmation" : "Är du säker på att du vill stänga av den här användaren från gruppen?",
    "deleteContentCheckbox" : "Radera varje Innehåll skapad av denna Användare",
    "active" : "Aktiv",
    "admins" : "Administratörer",
    "contributors" : "Bidragsgivare",
    "requested" : "Begärd",
    "banned" : "Bannlyst",
    "invited" : "Inbjuden",
    "answeredQuestions" : "Besvarade frågor",
    "answeredQuestionsMessage" : "svarade på följande fråga för att gå med",
    "darkMode" : "Mörkt läge",
    "darkModeMessage" : "Ändra utseendet på communityn för att motverka reflexer och ge dina ögon en paus.",
    "accessGranted" : "Åtkomst beviljad: börja ditt utbildningsäventyr.",
    "paymentReceived" : "Betalning har mottagits, och din begäran om att gå med i gruppen granskas.",
    "stepIntoAction" : "Gå till handling! Ska vi samarbeta och ha lite kul?",
    "viewMembersAndMemberDetails" : "Visa medlemmar och medlemsinformation",
    "reviewContentReportsAndMore" : "Granska innehållsrapporter med mera",
    "toReview" : "För granskning",
    "switchToOtherGroups" : "Byt till Annan Grupp",
    "placeholders" : {
      "yourAnswer" : "Ditt svar"
    },
    "notifications" : {
      "userBanned" : "Användaren har stängts av från gruppen",
      "somethingWentWrong" : "Något gick fel. Försök igen senare."
    },
    "membershipSettings" : "Inställningar för medlemskap",
    "paymentFailed" : "Betalningen misslyckades!",
    "paymentFailedMessage" : "Betalningen misslyckades och din förfrågan om att gå med i gruppen har avvisats.",
    "gamification" : {
      "addRewards" : "Lägg till belöningar",
      "title" : "Titel",
      "description" : "Lägg till beskrivning",
      "textbox" : "Textruta",
      "singleSelect" : "Enkelval",
      "multipleSelect" : "Flerval",
      "question" : "Fråga",
      "validations" : {
        "titleRequired" : "Ange titel",
        "descriptionRequired" : "Ange beskrivning",
        "somethingWentWrong" : "Något gick fel. Försök igen senare.",
        "updatedRewards" : "Uppdaterade belöningar"
      }
    },
    "customCode" : {
      "advanced" : "Avancerat",
      "testPreview" : "Testförhandsgranskning",
      "enableConfirmationMessage" : "Aktivera det inte förrän du har verifierat testförhandsgranskningen",
      "testPreviewMessage" : "Detta öppnar en ny flik med testförhandsvisningen av din grupp. Du kan använda detta för att kontrollera om din anpassade kod fungerar som förväntat.",
      "liveMode" : "Live -läge",
      "customJS" : "Anpassad JS",
      "customCSS" : "Anpassad CSS",
      "trackingCode" : "Spårningskod",
      "headerCode" : "Sidhuvud Kod",
      "footerCode" : "Sidfot Kod"
    },
    "branding" : {
      "brandYourGroup" : "Du kan profilera din grupp efter eget val här",
      "updateBranding" : "Uppdatera branding",
      "clickToUploadFavicon" : "Klicka för att ladda upp favikon",
      "dragAndDropFavicon" : "Dra och släpp en {types} (bildförhållande 1:1)",
      "clickToUploadCover" : "Klicka för att ladda upp omslag",
      "dragAndDropCover" : "Dra och släpp en {types} (bildförhållande 16:9)",
      "clickToUploadLogo" : "Klicka för att ladda upp gruppens logotyp",
      "dragAndDropLogo" : "Dra och släpp en {types} (bildförhållande 1:1)",
      "aspectRatioMustBe1To1" : "Bildförhållandet måste vara 1:1",
      "aspectRatioMustBe16To9" : "Bildförhållandet måste vara 16:9",
      "favicon" : "Favikon",
      "coverImage" : "Omslagsbild",
      "logo" : "Logotyp",
      "invalidFileFormat" : "Oj! Ogiltigt filformat/typ.",
      "pleaseUploadImageType" : "Filtyper som stöds: {types}"
    },
    "groupAppearance" : {
      "description" : "Du kan konfigurera din Grupp Utseende per ditt val här",
      "slug" : "Uppdatera din Grupp Utseende här",
      "colorMode" : "Färg",
      "previewTheLook" : "Förhandsgranska hur din Grupp kommer Utseende in Ljus- och Mörk-läge",
      "light" : "Ljus",
      "dark" : "Mörk",
      "communityTheme" : "community Tema",
      "customTheme" : "Anpassad Tema",
      "windowGradient" : "Fönster Gradient",
      "applyGradientColorsToYourSidebarAndTopbar" : "Tillämpa Gradient till sidofältet och toppfältet",
      "labels" : {
        "sidebarBackground" : "Bakgrund för sidofält",
        "primary" : "PRIMÄR",
        "secondary" : "Sekundär",
        "tertiary" : "Tertiär",
        "surface" : "Yta",
        "fontPrimary" : "PRIMÄR Typsnitt",
        "fontSecondary" : "Sekundärt Typsnitt",
        "fill" : "Fyll Färg",
        "border" : "Kantlinje",
        "error" : "Fel",
        "background" : "Bakgrund"
      },
      "customThemes" : {
        "default" : "Standard",
        "zestyCitrus" : "Snygg citrus",
        "royalVelvet" : "Kunglig sammet",
        "sunnyDelight" : "Sunny Delight",
        "lushMeadow" : "Frodig äng",
        "azureDreams" : "Azure Dreams",
        "bubblegumBliss" : "Bubblegum Bliss",
        "ivoryWhisper" : "Ivory Whisper",
        "midnightDeep" : "Midnattsdjup"
      },
      "unsavedChanges" : "Ej sparad Dynamisk",
      "unsavedChangesMessage" : "Du har osparat Tema Dynamisk, är du säker på att du vill Ångra the Dynamisk?"
    },
    "promotionalLinks" : {
      "promotionalLinks" : "Kampanjlänkar",
      "createPromotionalLinkDescription" : "Skapa kampanjlänkar för din grupp",
      "addPromotionalLink" : "Lägg till länk",
      "deleteLink" : "Radera länk",
      "deleteLinkConfirmation" : "Är du säker på att du vill radera den här länken?",
      "labels" : {
        "description" : "Beskrivning",
        "url" : "URL",
        "private" : "Privat",
        "privateLinksDescription" : "Privata länkar är bara synliga för gruppmedlemmar"
      },
      "placeholders" : {
        "enterLinkDescription" : "Ange länkbeskrivning",
        "enterLinkURL" : "Ange länkens URL"
      },
      "addPromotionalLinkDescription" : "Skapa Kampanjlänkar för din Grupp"
    },
    "membershipQuestions" : {
      "addQuestion" : "Lägg till fråga",
      "editQuestion" : "Redigera fråga",
      "editLevelName" : "Redigera nivånamn",
      "addOption" : "Lägg till alternativ",
      "level" : "Nivå",
      "name" : "Namn",
      "addMembersQuestionsDescription" : "Lägg till frågor för medlemmar som kan ställas när de ber om åtkomst till din grupp",
      "enableMembershipQuestions" : "Aktivera frågor om abonnemang",
      "membershipQuestions" : "Frågor om medlemskap",
      "deleteQuestion" : "Radera fråga",
      "deleteQuestionConfirmation" : "Är du säker på att du vill radera den här frågan?",
      "labels" : {
        "textBox" : "Textruta",
        "singleSelect" : "Enkelval",
        "multipleSelect" : "Flerval",
        "enableMembershipQuestions" : "Lägg till minst en Fråga till Aktivera medlemsskapsfrågor"
      },
      "validations" : {
        "questionRequired" : "Ange fråga",
        "answerOptionsRequired" : "Minst två alternativ krävs, och de måste vara unika",
        "somethingWentWrong" : "Något gick fel. Försök igen senare.",
        "updatedQuestions" : "Uppdaterade frågor om gruppmedlemskap",
        "levelNameRequired" : "Ange nivånamn",
        "updatedLevelName" : "Uppdaterade nivånamn"
      },
      "placeholders" : {
        "enterLevelName" : "Nivånamn",
        "selectOne" : "Välj en",
        "keepItShort" : "håll det kort …",
        "exampleOffer" : "t.ex 10% Inaktiverad På första köpet"
      },
      "privacyNotice" : "Jag förstår att mina svar kommer att vara Arkivera och synliga för Gruppens administratörer."
    },
    "gamificationAndRewards" : {
      "title" : "Anpassa nivåer och belöningar",
      "description" : "Anpassa nivånamn och lägg till belöningar för bättre engagemang från medlemmarna",
      "gamification" : "Gamification",
      "rewards" : "Belöningar",
      "addRewards" : "Lägg till belöning"
    },
    "invitations" : {
      "invitationSentSuccessfully" : "Inbjudan har skickats",
      "invitationSentSuccessfullyDescription" : "Inbjudan skickad till {email}",
      "shareGroupLink" : "Dela din grupplänk",
      "inviteMember" : "Bjud in medlem",
      "inviteMemberDescription" : "Bygg upp din community genom att bjuda in en ny medlem",
      "inviteViaEmail" : "Bjud in via e-post",
      "invitedMembersWillBeAutoApproved" : "Inbjudna medlemmar godkänns automatiskt som medlemmar i gruppen",
      "sendInvite" : "SKICKA INBJUDAN",
      "permissionDenied" : "Du har inte Auktorisering att bjuda in Medlemmar. Vänligen kontakta din administratör.",
      "labels" : {
        "giveAdministrativePrivileges" : "Ge administratörsbehörighet",
        "giveAdministrativePrivilegesDescription" : "Tillåt att den här medlemmen utför alla administrativa åtgärder",
        "name" : "Namn",
        "email" : "E-post"
      },
      "placeholders" : {
        "enterName" : "Ange namn",
        "enterEmail" : "Ange e-postadress"
      }
    },
    "groupDetails" : {
      "updateGroupDetails" : "Uppdatera gruppinformation",
      "updateGroupDetailsDescription" : "Uppdatera din gruppinformation här",
      "slugNotAvailable" : "Gruppens slug inte tillgänglig",
      "description" : "Förtydliga vilken typ av diskussioner som kommer att äga rum i gruppen",
      "publicDescription" : "Vem som helst kan se gruppens inlägg och andra medlemmar i gruppen",
      "privateDescription" : "Bara medlemmar kan se gruppens inlägg och andra medlemmar i gruppen",
      "accessibleFromSwitcher" : "Tillgängligt från växlare",
      "accessibleFromSwitcherDescription" : "Din grupp kommer att vara synlig för personer som inte är gruppmedlemmar i växlaren",
      "allowMembersToInvite" : "Aktivera Medlemmar bjuder in Ny Medlemmar",
      "allowMembersToInviteDescription" : "Dölj inbjudan Knapp för Medlemmar När blev Inaktiverad. Medlemmar kan bara bjuda in Annan Om detta är Aktiverad.",
      "slug" : "Gruppens slug",
      "discovery" : {
        "title" : "Upptäckt",
        "description" : "Bli upptäckt av miljontals aktiva användare. Gruppen kommer att synas på sidan Upptäck när du har fler än 10 medlemmar.",
        "discoverChannels" : "Upptäck kanaler",
        "joinGroupToExploreAllChannels" : "gå med gruppen för att utforska varje kanaler"
      },
      "placeholders" : {
        "description" : "Ange en kort beskrivning"
      },
      "validations" : {
        "nameRequired" : "Ange ett giltigt gruppnamn!",
        "slugRequired" : "Ange en giltig grupp-slug!",
        "specialCharacterNotSupported" : "Specialtecken stöds inte",
        "descriptionRequired" : "Gruppbeskrivning krävs!",
        "emailRequired" : "Ange en giltig e-postadress!",
        "fullNameRequired" : "Vänligen ange ett giltigt namn!"
      },
      "labels" : {
        "groupName" : "Grupp Namn"
      }
    },
    "subscriptions" : {
      "manageSubscriptions" : "Hantera din Abonnemang",
      "viewAndManageGroupSubscriptions" : "Visa och Hantera Grupp Abonnemang",
      "paymentIntegrationMissingMessage" : "Vänligen integrera betalningar in Plats till Aktivera Betald Grupp",
      "price" : "Pris",
      "currency" : "Valuta",
      "priceDisplay" : "{symbol}{price}{suffix}",
      "priceInterval" : "/{interval}",
      "oneTime" : " Ett datum",
      "priceDeletedAlert" : "Betalning är Från Synkronisering, klicka här för att synkronisera om",
      "intervals" : {
        "month" : "Månad",
        "year" : "År",
        "week" : "Vecka",
        "day" : "Dag"
      },
      "addNewPrice" : "Lägg till Ny Pris",
      "editPrice" : "Redigera Pris",
      "addPrice" : "Lägg till Pris",
      "subscriptionType" : {
        "recurring" : "Återkommande",
        "oneTime" : "Ett datum"
      },
      "billingPeriod" : {
        "monthly" : "Varje månad",
        "annually" : "Årligen",
        "weekly" : "Varje vecka",
        "daily" : "Dagligen"
      }
    },
    "menuOptions" : {
      "details" : "Detaljer",
      "subscriptions" : "Abonnemang",
      "branding" : "Branding",
      "themes" : "Tema",
      "membershipQuestions" : "Medlemskap",
      "gamificationAndRewards" : "Gamification och belöningar",
      "links" : "Länkar",
      "newsletter" : "Nyhetsbrev",
      "reportedContent" : "Rapporterat Innehåll",
      "discovery" : "Upptäckt",
      "import" : "Importera"
    },
    "newsletter" : {
      "title" : "Nyhetsbrev",
      "subheading" : "Ditt communitysammandrag",
      "frequency" : "Frekvens",
      "description" : "En Sammanfattning av populära inlägg, Medlemmar Aktivitet och instanser från denna Grupp",
      "selectFrequency" : "Klicka på frekvens"
    },
    "groupSettings" : {
      "groupSettings" : "Grupp Inställningar",
      "changeGroupType" : "Ändra Grupp Typ",
      "changeGroupTypeDescriptionPrivateToPublic" : "Dynamisk to a Offentlig Grupp innebär att varje Väntar Förfrågningar automatiskt blir Godkänd och Innehåll blir offentligt. Fortsätt?",
      "changeGroupTypeDescriptionPublicToPrivate" : "Dynamisk to a Privat Grupp betyder att Ny Medlemmar behöver Godkännande och Innehåll förblir Dold tills de blir Godkända. Fortsätt?",
      "changeGroupTypeConfirmation" : "Är du säker på att du vill Ändra Grupp Typ?",
      "changeGroupTheme" : "Ändra Grupp Tema",
      "changeGroupThemeDescription" : "Detta kommer Ändra Temat för varje Grupp Medlemmar. Är du säker på att du vill Ändra Grupp Tema?",
      "updatedGroupDetails" : "Uppdaterad Grupp Detaljer",
      "unableToSaveDetails" : "Hoppsan! Det gick inte att Arkivera Detaljer.",
      "groupNameIsRequired" : "Gruppen Namn Krävs",
      "groupDescriptionIsRequired" : "Grupp Beskrivning är Krävs",
      "groupSlugIsRequired" : "Grupp Slug är Krävs",
      "groupSlugMustContainOnly" : "Grupp Slug får endast innehålla Små bokstäver bokstäver, Antal och bindestreck",
      "groupSlugAlreadyExists" : "Grupp Slug finns redan. Använd en annan Slug eftersom den redan är hämtad",
      "groupSlugRestricted" : "Denna slug matchar ett av våra begränsade nyckelord för communitylänkar. Använd en annan slug",
      "pleaseTryAgainLater" : "Försök igen senare",
      "unsavedChangesMessage" : "Du har en osparad Grupp Slug Dynamisk, är du säker på att du vill Ångra dem?"
    },
    "import" : {
      "header" : "Importera Skool Grupp Medlemmar och deras Innehåll",
      "credentialDescription" : "Ange ditt Skool Certifikat för att importera din Grupp Medlemmar och deras Innehåll",
      "csvUploadDescription" : "Välj .csv Fil till Importera kontakter Från Skool",
      "loginFailed" : "Du har angett ett Ogiltigt E-post- Eller password. Försök igen.",
      "proceedWithImport" : "Fortsätt med Importera?",
      "iAgree" : "Jag håller med",
      "importTerms" : "Via att klicka på ”Jag godkänner” bekräftar och bekräftar Du att Du har anlitat oss som ett oberoende Avtal för att utföra Tjänster på din räkning (”Tjänster”). The Tjänster Inkludera the Överför av certain data, Detaljer, Innehåll, intellectual Egenskaper Eller any Annan Innehåll (\"Info\") Från a Utfärdade Platform Konto to a Mottagen Platform Konto. Du representerar och garanterar att (i) Du är de rätta Ägare av Info in Utfärdadeplattformen Konto, (ii) Du har Behörigheter att ge oss Åtkomst till Utfärdadeplattformen Konto för Avsikt av som utför Tjänsten, och (iii) the Överför av the Info kommer inte att inkräkta på någon tredje parts intellektuella Egenskaper Behörigheter Eller bryter mot några tredjepartsavtal. Du samtycker till att ersätta, försvara och pausa oss ofarliga för tredje parts anspråk som uppstår som resultat av ditt brott från ovanstående representanter och garantier.",
      "pleaseDownloadCSV" : "Ladda ner .CSV-filen",
      "step01" : "Steg 01-",
      "step02" : "Steg 02-",
      "uploadCSV" : "Ladda upp din .CSV",
      "step01Description" : "Fyll in Eller uppdatera eventuella saknade detaljer för Gruppmedlemmar som t.ex. Gmail, förnamn etc. Se till att CSV filen laddas upp in",
      "thisTemplate" : "det här köpcentret",
      "importCSV" : "Importera .CSV",
      "reSyncData" : "Re-Synkronisering av dina uppgifter Före Ladda ner.",
      "refreshUserList" : "Uppdatera Användare Lista",
      "reSyncDataDescription" : "Om Ny Användare läggs till in tiden föreslår vi att Du uppdaterar din lista och laddar ner CSV:en .",
      "pleaseDontChangeProfileSlug" : "Snälla, inte Ändra Profil Slug.",
      "selectFile" : "Välj Fil",
      "changeFile" : "Ändra Fil",
      "importMembersFailedText" : "Det kan bero på att de saknar e-postadress. Vänligen boka din Importera Fil och Försök igen med giltig e-postadress till dessa Medlemmar.",
      "upload" : "Ladda upp",
      "tryAgain" : "Försök igen",
      "syncAllPosts" : "Synkronisering varje din Story och kommentar",
      "membersCouldNotBeAdded" : "Medlemmar kunde inte läggas till i gruppen.",
      "importMembersSuccess" : "Vi har skickat ett e-postinlägg till varje Individ Grupp Medlemmar, där vi bekräftar deras Medlemskap in Gruppen och förser dem med Åtkomstdetaljer. Detta hjälper till att säkerställa att varje Medlemmar är informerad och kan Åtkomst med Gruppen på ett effektivt sätt.",
      "importMembersAdded" : "Medlemmar har lagts till i gruppen",
      "postsNotSynced" : "Återstående tjänster kunde inte Synkronisering till Gruppen. Det kan bero på att Story Författare inte importerades framgångsrikt.",
      "migrationFailed" : "Migreringen misslyckades. Försök igen.",
      "migrationCompleted" : "Migration Klar!",
      "migrationInProgress" : "Migrering in !",
      "uploadingInProgress" : "Ladda upp in !",
      "listMembers" : "Lista av Medlemmar blir",
      "downloaded" : "Ladda ner",
      "uploaded" : "laddade upp",
      "listPostsDownloaded" : "Lista av inlägg är Ladda ner.",
      "listPostsDownloading" : "Lista av inlägg laddas ner.",
      "posts" : "inlägg",
      "members" : "Medlemmar",
      "imported" : "importerade",
      "step1" : "Steg 1",
      "step2" : "Steg 2",
      "step1Description" : "Skapa en medlemsprofil in Skool Grupp.",
      "step1Description2" : "(inklusive Namn, e-post Id och lösenord)",
      "step2Description" : "Ange Skool Medlemmar Certifikat",
      "emailPlaceholder" : "Ange din Skools e-post- Id",
      "emailTooltip" : "Gå in i e-postmeddelandet Medlemmar med ditt Skool Konto",
      "passwordPlaceholder" : "Ange lösenordet för din Skool",
      "confirm" : "Bekräfta",
      "validation" : {
        "skoolUrl" : "Ange en giltig Skool-URL",
        "email" : "E-post är Krävs",
        "password" : "Lösenordet är Krävs"
      }
    }
  },
  "invitations" : {
    "intent" : "Hjälp den här communityn att växa!",
    "cancelInvitation" : "Avbryt inbjudan",
    "inviteMembers" : "Bjud in medlemmar att samarbeta i den här communityn.",
    "inviteLink" : "Inbjudningslänk",
    "buildYourCommunity" : "Bygg upp din community!",
    "inviteMembersToCollaborate" : "Du har skapat en ny community! Bjud in medlemmar att samarbeta i den här communityn.",
    "invite" : "Bjud in"
  },
  "createPost" : {
    "title" : "Skapa nytt blogginlägg",
    "placeholder" : "Vad tänker du på?",
    "liveStream" : "Live Stream",
    "slug" : "URL-slug för blogginlägg",
    "titleHelp" : "Titeln, beskrivningen och bilden kommer att användas som SEO-metataggar",
    "nameLabel" : "Blogginläggets titel",
    "nameValidation" : "Titel krävs",
    "descriptionLabel" : "Inläggets beskrivning",
    "descriptionHelp" : "Ge en kort beskrivning som ger läsarna ett smakprov av inlägget. Fungerar bäst mellan 100–250 tecken",
    "descriptionValidation" : "Beskrivning krävs",
    "createLabel" : "Skapa inlägg",
    "image" : "Blogginläggets bild",
    "imageDescription" : "Rekommenderad storlek är 600px * 400px",
    "notificationTitle" : "Blogginlägg skapat",
    "notificationErrorTitle" : "Det gick inte att skapa blogginlägget",
    "postingIn" : "Lägger upp in",
    "editingIn" : "Redigerar in"
  },
  "post" : {
    "downloadRecording" : "Download Recording",
    "deletePost" : "Radera inlägg",
    "reportPost" : "Anmäl inlägg",
    "editPost" : "Redigera inlägg",
    "createPost" : "Skapa inlägg",
    "publish" : "Publicera",
    "publishPost" : "Publicera inlägg",
    "addChannel" : "Lägg till kanal",
    "selectChannel" : "Välj kanal",
    "addLink" : "Lägg till länk",
    "removeLink" : "Ta bort länk",
    "update" : "Uppdatera",
    "unsavedChanges" : "Du har ändringar som inte har sparats",
    "unsavedChangesMessage" : "Du förlorar dina osparade ändringar. Vill du fortsätta ändå?",
    "unpinFromChannel" : "Lossa",
    "unpinFromHome" : "Lossa",
    "deletePostConfirmation" : "Är du säker på att du vill radera det här inlägget?",
    "reportPostConfirmation" : "Är du säker på att du vill rapportera det här inlägget?",
    "postNotFound" : "Inlägget hittades inte",
    "postNotFoundMessage" : "Inlägget du försöker visa har antingen raderats eller finns inte.",
    "loadMoreComments" : "Ladda fler kommentarer",
    "channelNotFound" : "Kanalen hittades inte",
    "isCurrentlyLive" : "är för närvarande live",
    "isStartingNow" : "börjar nu",
    "isHappeningInMinutes" : "händer om {minutes} min",
    "isHappeningInHours" : "händer in {hours} timme | händer in {hours} timme",
    "publicChannel" : "Offentlig kanal",
    "privateChannel" : "Privat kanal",
    "featured" : "Utvalda",
    "featuredAbout" : "Om utvalda",
    "noPostsFound" : "Inga inlägg hittades",
    "pinInfo" : "Du kan fästa objekt som ska visas längst upp i gruppen, inklusive inlägg, regler och hashtaggar.",
    "pinInfoEveryone" : "Alla i gruppen kommer att se de här objekten.",
    "pinInfoRemainVisible" : "Fästa objekt förblir synliga tills du lossar dem.",
    "pinInfoNewestItem" : "När du fäster objekt visas det senaste objektet längst fram i listan.",
    "onlyVisibleToAdmins" : "Endast synlig för administratörer",
    "featuredAboutDescription" : "Dina administratörer har fäst de här objekten så att gruppen kan se dem.",
    "channelNotFoundMessage" : "Du är inte längre medlem i kanalen du försöker komma åt eller också har kanalen raderats.",
    "notifications" : {
      "unpinned" : "Lossad!",
      "pinned" : "Fäste!",
      "reported" : "Inlägget har rapporterats!",
      "error" : "Någonting gick fel!",
      "isCommentDisabled" : "Feedback inaktiverad!",
      "isCommentEnabled" : "Kommentarer aktiverade!"
    },
    "movePostToChannel" : "Flytta till Kanal",
    "pin" : "Nåla",
    "pinToHome" : "Fäst till Hem",
    "pinToChannel" : "Fäst till Kanal",
    "whatIsYourTitle" : "Vad är din titel?",
    "postMovedToChannel" : "Story flyttades till kanal {channelName}",
    "turnOffCommenting" : "Inaktivera kommentering",
    "enableComments" : "Aktivera kommentarer.",
    "disableComments" : "Inaktivera feedback",
    "moveToPrivateChannelConfirmation" : {
      "title" : "Flytta till privat kanal",
      "message" : "Du håller på att flytta det här inlägget till en privat kanal. Endast medlemmar av den privata kanalen kommer att kunna se det. Vill du fortsätta?"
    },
    "onlyAdminsCanPost" : "Endast community-administratörer kan Dela in den här Kanalen."
  },
  "reaction" : {
    "noLikes" : "Inga gilla-markeringar",
    "andOthers" : "och {count} andra"
  },
  "UIConfirmation" : {
    "privateGroup" : "Den här gruppen är privat",
    "privateGroupMessage" : "Du måste vara medlem i den här gruppen för att få åtkomst till gruppspecifik information. Be om åtkomst genom att klicka på knappen Gå med i grupp."
  },
  "notifications" : {
    "noNotificationsYet" : "Inga aviseringar än",
    "whenYouGetNotifications" : "När du får aviseringar visas de här",
    "markAllAsRead" : "Markera alla som lästa",
    "notifications" : "Aviseringar",
    "all" : "Alla",
    "unread" : "Oläst",
    "checkNotifications" : "Logga in för att visa aviseringar",
    "noNotifications" : "Inga aviseringar!",
    "redirectedFromOldSlug" : {
      "title" : "Du har blivit omdirigerad till den uppdaterade community-länken.",
      "content" : "Detta har gjorts för att förbättra SEO-prestanda för denna community. Vänligen Uppdatera dina bokmärken med den nya URL:en."
    }
  },
  "joinGroupModal" : {
    "wahoo" : "Jippi! 🎉 Förfrågan har skickats",
    "reviewRequestSoon" : "Våra gruppadministratörer kommer snart att granska din förfrågan. Ha tålamod! Vi meddelar dig när ditt medlemskap har godkänts.",
    "nonMemberMessage" : "Du måste vara medlem i den här gruppen för att gilla och kommentera inlägg",
    "subscribeFor" : "Prenumerera på",
    "joinGroup" : "GÅ MED I GRUPPEN",
    "membershipPending" : "Medlemskap PENDING",
    "viewMembershipAnswers" : "Visa Medlemskap",
    "requested" : "Begärd",
    "dayFreeTrial" : "dags gratis provperiod",
    "notPartOfGroup" : "Du är inte en del av den här gruppen än, ditt Medlemskap Förfrågningar är in Recension. När en Admin Godkänd dina Förfrågningar kommer vi att meddela Du",
    "pleaseAnswerMembershipQuestions" : "Vänligen svara på medlemsfrågorna för att gå med denna Grupp",
    "answerQuestions" : "Svara på medlemskapsfrågor"
  },
  "userProfilePopover" : {
    "active" : "Aktiv",
    "longAgo" : "för länge sedan",
    "chatDisabled" : "Den här användaren har inaktiverat sin chatt",
    "pointsToLevelUp" : "poäng för att gå upp i nivå",
    "profile" : "Profil",
    "deletedUser" : "Raderad användare",
    "joined" : "Gick med",
    "contributions" : "Bidrag"
  },
  "courses" : {
    "courseRestricted" : "Denna Rutt är Privat",
    "courseDeleted" : "Den här kursen har raderats",
    "noMatchingCourseFound" : "Ingen matchande kurs hittades",
    "addCourse" : "Lägg till kurs",
    "updateCourse" : "Uppdatera kurs",
    "access" : "Alla medlemmar har tillgång",
    "unableToAddCourse" : "Hoppsan! Det gick inte att lägga till kursen",
    "pleaseTryAgainLater" : "Försök igen senare",
    "paymentIntegrationMissing" : "Hoppsan! Betalningsintegration saknas",
    "paymentIntegrationMissingMessage" : "Integrera betalningar på plats för att aktivera betalda kurser",
    "course" : "Kurs",
    "courseInThisGroup" : "en nuvarande rutt i den här communityn",
    "courseLinkCopied" : "Kurslänken har kopierats!",
    "buyNow" : "KÖP NU",
    "locked" : "LÅST",
    "buyCourse" : "KÖP KURS",
    "open" : "ÖPPEN",
    "moveCard" : "Flytta kort",
    "courseViewMessage" : "Du måste vara medlem i den här gruppen för att visa kurserna.",
    "deleteCourse" : "Radera kurs",
    "deleteCourseConfirmation" : "Är du säker på att du vill radera den här kursen?",
    "courseAccessNotGranted" : "Tillgång till kursen har inte beviljats",
    "courseAccessNotGrantedMessage" : "Vi arbetar för närvarande med att ge dig tillgång till kursen. Uppdatera sidan och försök igen om en stund.",
    "autoRenewsAfter" : "Förnyas automatiskt efter",
    "oneTimePayment" : "Engångsbetalning",
    "emptyCoursesMessage" : "Ser ut som en spökstad. Här finns inget att se",
    "updatedSuccessfully" : "Kursen Uppdaterad har genomförts",
    "addedSuccessfully" : "Kursen har lagts till",
    "createCourse" : "Skapa ny kurs",
    "emptyCourseLibrary" : "Ditt ruttbibliotek är tomt!",
    "createdOutsideGokollabMessage" : "Denna community skapades utanför Gokollab & gjordes synlig. För att Generera Ny Kurser, vänligen logga in på community Från dess Källa Kanal",
    "createCourseOnGokollabMessage" : "Generera en Ny Rutt På Gokollab för att Skapa den tillgänglig för dina community Medlemmar.",
    "or" : "eller",
    "createNewOne" : "skapa en ny",
    "labels" : {
      "selectCourse" : "Välj kurs",
      "courseVisibility" : "Kursens Synlighet",
      "courseAccess" : "Tillgång till kurs",
      "coursePrice" : "Kursens pris",
      "subscriptionType" : "Typ av abonnemang",
      "billingPeriod" : "Faktureringsperiod",
      "testMode" : "Testläge",
      "turnOnTestPayments" : "Aktivera testbetalningar med hjälp av ett testkort",
      "currency" : "Valuta",
      "trialDays" : "Provperiod",
      "recurring" : "Återkommande",
      "free" : "Gratis",
      "oneTime" : "Ett datum",
      "refresh" : "Uppdatera",
      "accessStartsAtDay" : "Åtkomst börjar kl . Dag",
      "maximumYouCanEnterIs365" : "Max som du kan delta i är 365",
      "allMembers" : "Varje Medlemmar",
      "levelUnlock" : "Jämn Lås upp",
      "buyNow" : "Köp nu",
      "timeUnlock" : "Lås upp datum",
      "gamificationLevel" : "Gamification Jämn",
      "privateChannel" : "Privat Kanal",
      "marketingChannel" : "Marknadsföring"
    },
    "placeholders" : {
      "enterPrice" : "Ange pris",
      "enterTrialDays" : "Ange dagar för provperiod",
      "selectCurrency" : "Välj en",
      "selectBillingPeriod" : "Välj en"
    },
    "validations" : {
      "validPrice" : "Ange ett giltigt pris",
      "required" : "Välj en kurs",
      "validMembershipPrice" : "Ange ett giltigt medlemspris",
      "validTrialDays" : "Ange giltigt antal dagar för provperiod",
      "requiredSubscriptionType" : "Välj typ av abonnemang",
      "courseVisibility" : "Vänligen välj kurs Synlighet",
      "requiredGamificationLevel" : "Vänligen välj Gamification Jämn",
      "requiredPrivateChannel" : "Vänligen välj Privat kanal",
      "validAccessStartDay" : "Vänligen ange giltig Åtkomst start Dag"
    },
    "descriptions" : {
      "buyNowDescription" : "Kursen är Offentlig vid köp",
      "timeUnlockDescription" : "Medlemmar Lås upp Efter X dagar",
      "levelUnlockDescription" : "Medlemmar kommer endast vid en viss Jämn att kunna låsa upp",
      "allMembersDescription" : "Varje Medlemmar har Åtkomst till denna kurs",
      "privateChannelDescription" : "Medlemmar av en Privat kanal"
    },
    "helperText" : {
      "levelBased" : "Nivåbaserad",
      "timeLimited" : "timme-Limited",
      "free" : "Gratis",
      "levelAvailableAt" : "Finns på Jämn 0{value}",
      "timeLimitedAfterJoining" : "Offentlig {value} {day} Efter att ha gått med i gruppen",
      "day" : "Dag",
      "days" : "dagar",
      "purchaseToUnlockAccess" : "Köp den här kursen för att låsa upp Åtkomst",
      "locked" : "Kursen är låst",
      "unlockAtLevel" : "Den här kursen kommer att låsas upp på Jämn {level}",
      "unlockAfterDays" : "Den här kursen kommer att låsas upp Efter {days} {dayText}",
      "privateChannelBased" : "Privat kanalbaserad"
    }
  },
  "leaderboard" : {
    "level" : "Nivå",
    "lastUpdated" : "Senast uppdaterad",
    "members" : "Medlemmar",
    "percentOfMembers" : "{percentage}% av medlemmarna",
    "rewards" : "Belöningar",
    "allTime" : "Genom tiderna",
    "pointsToLevelUp" : "poäng för att gå upp i nivå",
    "points" : "Poäng",
    "leaderboard7d" : "Topplista (7 dagar)",
    "leaderboard30d" : "Topplista (30 dagar)",
    "leaderboardAlltime" : "Topplista (genom tiderna)",
    "yourRank" : "Din placering",
    "noActivityToShow" : "Ingen aktivitet att visa",
    "rewardsWillBeDisplayedHere" : "Belöningar kommer att visas här",
    "seeAllLeaderboards" : "Se alla topplistor",
    "addRewards" : "Lägg till belöningar",
    "howPointsWork" : "Du tjänar poäng när andra medlemmar gillar dina inlägg eller kommentarer. 1 gilla-markering = 1 poäng. Detta uppmuntrar användare att skapa kvalitetsinnehåll och interagera med andra medlemmar i deras community.",
    "levels" : "Nivåer",
    "levelsDescription" : "När du får poäng går du upp i nivå. Din nivå visas längst ner till höger om din avatar. Antalet poäng som krävs för att komma till nästa nivå visas i förloppsindikatorn på skärmen med topplistan.",
    "pointsAndLevels" : "Poäng & Lager"
  },
  "events" : {
    "createEvent" : "Skapa händelse",
    "dragAndDrop" : "Dra och släpp en SVG, PNG eller JPG (max 800 x 400 px)",
    "editEvent" : "Redigera händelse",
    "addEvent" : "Lägg till händelse",
    "paymentDetails" : "Betalningsuppgifter",
    "event" : "Händelse",
    "goBack" : "Gå tillbaka",
    "cancelEdit" : "Avbryt redigering",
    "cancelEvent" : "Annullera händelse",
    "next" : "Nästa",
    "saveEvent" : "Spara händelse",
    "editRecurringEvent" : "Redigera återkommande händelse",
    "thisEvent" : "Denna händelse",
    "thisAndFollowingEvents" : "Den här och återkommande händelser",
    "ok" : "OK",
    "deleteRecurringEvent" : "Radera återkommande händelse",
    "allEvents" : "Alla händelser",
    "adminsFreeForPaidEvents" : " * Administratörer kan registrera för Betald Händelser gratis",
    "deleteEvent" : "Radera händelse",
    "onceEventDeleted" : "När händelsen har raderats visas den inte i din kalender.",
    "toRegister" : "att registrera sig",
    "calendar" : "Kalender",
    "addToCalendar" : "Lägg till i kalendern",
    "declineRegistration" : "Avböj",
    "paymentFailedMessage" : "Din betalning misslyckades på grund av några oförutsedda omständigheter! Försök igen senare.",
    "upcoming" : "Kommande",
    "noMoreEvents" : "Inga fler händelser att visa",
    "joinGroupToRegister" : "Du måste vara medlem i den här gruppen för att registrera dig till den här händelsen",
    "past" : "Tidigare",
    "youHaveRegisteredForOneEvent" : "Du har registrerat dig till 1 händelse. Vi skickar en påminnelse till dig en dag före varje händelse.",
    "upcomingEvents" : "Kommande händelser",
    "noUpcomingEvents" : "Inga kommande händelser",
    "pastEvents" : "Tidigare händelser",
    "noPastEvents" : "Inga tidigare händelser",
    "noMatchingEventFound" : "Ingen matchande händelse hittades",
    "week" : "Vecka",
    "month" : "Månad",
    "today" : "Idag",
    "registrationConfirmed" : "Registrering Bekräftad för {event}.",
    "eventDeletedOrRestricted" : "Händelsen är Raderad eller Privat",
    "eventDeleted" : "Händelsen har raderats",
    "eventRestricted" : "Du har inte tillgång till det här evenemanget",
    "validations" : {
      "titleValidation" : "Titel krävs",
      "colorValidation" : "Färg krävs",
      "startTimeValidation" : "Starttid krävs",
      "endTimeValidation" : "Sluttid krävs",
      "endTimeAfterStartTime" : "Sluttiden måste vara efter starttiden",
      "startTimeMustBeInFuture" : "Starttiden måste vara i framtiden",
      "locationValidation" : "Plats krävs",
      "locationValidationMobile" : "Plats krävs",
      "locationUrlValidation" : "Giltig URL för plats krävs",
      "descriptionValidation" : "Beskrivning krävs",
      "descriptionValidationMaxLength" : "Beskrivningen får inte överstiga 300 tecken",
      "recaptchaError" : "Verifieringen misslyckades! Försök igen",
      "repeatIntervalValidation" : "Förekomst krävs",
      "repeatIntervalValidator" : "Upprepningsintervallet måste vara antingen dag, vecka, månad eller år",
      "repeatIntervalRequired" : "Upprepningsintervall krävs",
      "repeatOccurrenceValidator" : "Upprepad frekvens måste vara större än 0",
      "repeatOccurrenceRequired" : "Upprepad frekvens krävs",
      "invalidDateFormat" : "Ogiltigt datumformat",
      "endDateMustBeAfterStartDate" : "Slutdatum måste vara efter händelsens startdatum",
      "recurringEndDateValidation" : "Slutdatum för återkommande händelse krävs",
      "repeatsOnValidation" : "Välj minst en dag",
      "invalidDaySelection" : "Ogiltigt val av dag",
      "endOptionRequired" : "Slutalternativ krävs",
      "levelValidation" : "Välj en nivå",
      "courseValidation" : "Välj en kurs",
      "channelValidation" : "Välj en kanal",
      "eventPriceValidation" : "Pris är Krävs och måste vara högre än {min}"
    },
    "placeholders" : {
      "selectStartTime" : "Välj starttid",
      "selectEndTime" : "Välj sluttid",
      "selectLocation" : "Välj plats",
      "locationUrl" : "Länk/adress",
      "description" : "Beskrivning",
      "selectRecurringEndDate" : "Välj återkommande slutdatum",
      "selectDate" : "Välj datum",
      "event" : "Händelse",
      "selectColor" : "Välj en färg",
      "selectAttendees" : "Välj deltagare",
      "selectPrivateChannel" : "Välj privat kanal",
      "selectCourse" : "Välj kurs",
      "selectLevels" : "Välj nivåer",
      "selectCalendar" : "Välj kalender"
    },
    "labels" : {
      "startTime" : "Starttid",
      "endTime" : "Sluttid",
      "others" : "Andra",
      "oneTimePriceForEventRegistration" : "engångspris för händelseregistrering.",
      "totalAmount" : "Totalt belopp",
      "cardAuthorizationText" : "Genom att ange dina kortuppgifter tillåter du att {locationName} drar framtida betalningar från kortet i enlighet med deras villkor.",
      "secureAndSafePayments" : "100 % säkra och trygga betalningar",
      "day" : "Dag",
      "week" : "Vecka",
      "month" : "Månad",
      "year" : "År",
      "recurringEvent" : "Är det en återkommande händelse?",
      "repeatsEvery" : "Upprepas varje",
      "repeatsOn" : "Upprepas på",
      "end" : "Slut",
      "ends" : "Slampa",
      "neverEnds" : "Slutar aldrig",
      "orange" : "Orange",
      "red" : "Röd",
      "blue" : "Blå",
      "green" : "Grön",
      "violet" : "Violett",
      "purple" : "Lila",
      "yellow" : "Gul",
      "title" : "Titel",
      "color" : "Färg",
      "allMembers" : "Alla medlemmar",
      "membersAtALevel" : "Medlemmar på en nivå",
      "membersOfACourse" : "Medlemmar på en kurs",
      "membersOfAPrivateChannel" : "Medlemmar i en privat kanal",
      "whoCanAttendTheEvent" : "Vem kan delta i händelsen?",
      "channel" : "Kanal",
      "course" : "Kurs",
      "level" : "Nivå",
      "remindAttendeesByEmail" : "Påminn deltagarna Via E-post 1 Dag Före",
      "hideLocationFromNonAttendees" : "Dölj plats för personer som inte deltar.",
      "addChargesToTheEvent" : "Lägg till fakturering i Händelsen",
      "noPaymentRequired" : "Ingen betalning Krävs",
      "location" : "Plats",
      "link" : "Länk",
      "description" : "Beskrivning",
      "timezone" : "Tidszon",
      "eventType" : "Händelsetyp",
      "eventTypeChangeWarning" : "Dynamisk till Händelsetyp Eller prissättning kommer Tillämpa till varje instanser in serien.",
      "never" : "Aldrig",
      "on" : "På",
      "after" : "Efter",
      "occurrences" : "instanser",
      "selectEventEnd" : "Välj När the Händelse will Slut.",
      "turnOnTestPayments" : "Vänd På Test Via Test",
      "pay" : "Betala",
      "hideAttendees" : "Dölj attendees Från Grupp Medlemmar",
      "guests" : "{count} gäster",
      "guestList" : "Gäst Lista",
      "noAttendees" : "Inga deltagare än",
      "viewAttendees" : "Visa deltagare",
      "exportAttendees" : "Exportera deltagare"
    },
    "notifications" : {
      "eventCreated" : "Händelse framgångsrikt skapat!",
      "eventUpdated" : "Händelse har Uppdaterad framgångsrikt!",
      "eventCreationFailed" : "Det gick inte att skapa Händelse !",
      "eventUpdateFailed" : "Uppdateringen av Händelse misslyckades!",
      "eventDeleted" : "Händelsen har tagits bort!",
      "eventDeletionFailed" : "Det gick inte att radera händelsen!",
      "paymentFailed" : "Betalningen misslyckades!",
      "registrationSuccessful" : "Registreringen lyckades!",
      "registrationFailed" : "Registreringen misslyckades!",
      "addToCalendarFailed" : "Det gick inte att lägga till händelsen i kalendern!",
      "locationDetailsCopied" : "Platsinformation kopierad till urklipp!",
      "registrationDeclined" : "Registreringen avvisades!",
      "registrationDeclinedFailed" : "Avvisning av registrering misslyckades!",
      "fetchAttendeesFailed" : "Det Misslyckades att ladda deltagarna",
      "emailCopied" : "E-post Kopierad till urklipp"
    }
  },
  "login" : {
    "invite" : "har bjudit in dig att gå med i"
  },
  "contentReports" : {
    "contentDeleted" : "Innehållet har raderats!",
    "noActionTaken" : "Ingen åtgärd vidtogs på det rapporterade innehållet!",
    "reportedContentNotFound" : "Det rapporterade innehållet hittades inte, kanske redan har åtgärdats.",
    "reported" : "Rapporterad",
    "viewAllReportedContentHere" : "Du kan visa allt rapporterat innehåll här",
    "takeActionOnReportedContent" : "Vidta åtgärder mot det rapporterade innehållet",
    "andOthers" : "och {count} andra",
    "reportedThisPost" : "har rapporterat det här inlägget",
    "keep" : "BEHÅLL",
    "remove" : "TA BORT",
    "deleteContent" : "Ta bort innehåll",
    "deleteConfirmation" : "Är du säker på att du vill radera det här innehållet?",
    "noMemberReportedContent" : "Inget medlemsrapporterat innehåll",
    "whenMembersReportPostsOrComments" : "När medlemmar rapporterar inlägg eller kommentarer visas de här så att du kan granska dem. Du kan behålla eller radera dem, samt stänga av, ta bort eller blockera medlemmarna som har publicerat dem."
  },
  "contentUnavailable" : {
    "thisContentIsntAvailable" : "Det här innehållet är inte tillgängligt för tillfället",
    "whenThisHappens" : "När detta händer beror det vanligtvis på att ägaren bara har delat det med en liten grupp personer eller ändrat vem som kan se det, eller också har det raderats"
  },
  "noCommunities" : {
    "noCommunitiesFound" : "Inga communities hittades",
    "startCreatingYourOwnCommunities" : "Börja skapa dina egna communities och interagera med din målgrupp!",
    "noCommunitiesFoundGokollab" : {
      "notJoinedA" : "Har inte gått med i någon",
      "communities" : "Communities",
      "yet" : "än"
    },
    "noCommunitiesFoundGokollabDescription" : "Upptäck platser där människor delar idéer, stöttar varandra och utvecklas tillsammans."
  },
  "noCourses" : {
    "noCoursesFoundGokollab" : {
      "notEnrolledInA" : "Har inte registrerat sig till någon",
      "course" : "Kurs",
      "yet" : "än"
    },
    "noCoursesFoundGokollabDescription" : "Utforska effektiva kurser som är utformade för att hjälpa dig att lära dig, utveckla dig och lyckas."
  },
  "notFound" : {
    "ohNo" : "åh nej …",
    "weHaveHadAnError" : "Vi har haft ett fel",
    "error404" : "Fel 404",
    "sorryPleaseCheckBack" : "Ursäkta … kom tillbaka om en liten stund."
  },
  "time" : {
    "justNow" : "Just nu",
    "timeAgo" : "{value} {unit} sedan",
    "timeAgoFull" : "{value}  {unit} sedan",
    "units" : {
      "year" : "å",
      "years" : "år",
      "month" : "mån",
      "months" : "månader",
      "week" : "v",
      "weeks" : "veckor",
      "day" : "d",
      "days" : "dagar",
      "hour" : "t",
      "hours" : "timmar",
      "minute" : "m",
      "minutes" : "minuter",
      "second" : "s",
      "seconds" : "Sekunder",
      "monthly" : "Varje månad",
      "weekly" : "Varje vecka",
      "annually" : "Årligen"
    }
  },
  "emojiPicker" : {
    "notfound" : "Ingen emoji hittades",
    "recent" : "Används ofta",
    "smileys" : "Smileys och uttryckssymbol",
    "people" : "Människor & Brödtext",
    "nature" : "Djur och natur",
    "foods" : "Mat & dryck",
    "activity" : "Aktivitet",
    "places" : "Resor & Platser",
    "objects" : "Objekt",
    "symbols" : "Symboler",
    "flags" : "Flaggor",
    "custom" : "Anpassad"
  },
  "topNavBarHeaderText" : {
    "discussion" : "Diskussion",
    "learning" : "utbildning",
    "people" : "Människor"
  },
  "globalUserProfile" : {
    "ownedBy" : "Ägs av {name}",
    "memberships" : "Medlemskap",
    "membershipsInCommon" : "Medlemskap ({count} gemensamma)",
    "membersCount" : "{count} medlemmar",
    "contributions" : "{count} bidrag till {group}",
    "contributionsFor" : "Bidrag för",
    "justPosts" : "Endast inlägg",
    "postAndComments" : "Inlägg och kommentarer",
    "followSuccess" : "Du har börjat följa",
    "unfollowSuccess" : "Du följer inte längre"
  },
  "profile" : {
    "active" : "Aktiv",
    "ago" : "sedan",
    "bio" : "Biografi"
  },
  "golive" : {
    "golive" : "Go Live",
    "selectVideoSourceToStart" : "Select a video source to start streaming",
    "chooseHowToGoLive" : "Choose how you want to go live",
    "streamingSoftware" : "Streaming Software",
    "streamingSoftwareDescription" : "You can use a streaming software like Zoom, OBS, or StreamYard to broadcast directly. Simply copy the provided Stream URL and Stream Key into your streaming software’s settings. Once configured, start your broadcast in the software, and it will stream live to your selected platform automatically.",
    "streamKey" : "Stream Key",
    "streamKeyDescription" : "This stream key is only valid for single use.",
    "serverUrl" : "Server URL",
    "serverUrlDescription" : "This maybe referred to as \"URL\" or \"Address\" in your streaming software.",
    "selectVideoSource" : "Select Video Source",
    "copyPasteStreamKey" : "Copy and paste the stream key into your streaming software.",
    "copyPasteServerUrl" : "Copy and paste the server URL into your streaming software.",
    "addPostDetails" : "Add Post Details",
    "enterTitle" : "Enter Title",
    "notifyMembers" : "Notify members you're going live (sends only in-app and push notifications)",
    "notifyMembersMobile" : "Notify members you're going live",
    "meetingRoom" : "Meeting Room",
    "meetingRoomDescription" : "Use the Meeting Rooms feature to host live sessions where all participants can turn on their webcams, unmute, and interact in real-time. This creates a virtual room experience similar to Zoom or Google Meet, allowing everyone to see and talk to each other face-to-face.",
    "cameraControls" : "Camera Controls",
    "cameraControlsTooltip" : "Configure your camera and audio settings before going live. Make sure your camera and microphone are properly connected and have the necessary permissions.",
    "selectMediaSource" : "Select a media source",
    "startScreenShare" : "Start screen share",
    "stopScreenShare" : "Stop screen share",
    "wasLive" : "was live",
    "isLive" : "is live",
    "goingLive" : "is going live",
    "tapToAddDescription" : "Tap to add a description...",
    "selectChannel" : "Select Channel",
    "saveAsPost" : "Keep live stream as post",
    "selectVideoSourceTooltip" : "You can choose between Streaming Software or Webcam when going live:\n\n1. Streaming Software\n   • We will provide you with a Stream Key and Stream URL.\n   • You need to configure these in Zoom, OBS, or any third-party software that supports live streaming.\n\n2. Webcam\n   • Go live directly using your camera and microphone.\n   • Participants can view the live stream and interact through the live chat.\n   • As the host, you can control and revoke access to the camera or microphone at any time.",
    "pleaseSelectCameraMicrophoneSpeaker" : "Please select camera, microphone and speaker",
    "pleaseStartStreamBeforeGoingLive" : "Please start the stream before going live",
    "live" : "Live",
    "watching" : "Watching",
    "processingRecording" : "Processing Recording",
    "streamEndedRecordingWillBeAvailableSoon" : "Stream ended. The recording is being processed and will be available shortly.",
    "joinStream" : "Join Stream",
    "recordingInProgress" : "Recording in progress",
    "recordingNotAvailable" : "Recording not available",
    "leaveSession" : "Leave Session",
    "endSession" : "End Session",
    "participants" : "Participants",
    "chats" : "Chats",
    "react" : "React",
    "raise" : "Raise",
    "shareScreen" : "Share",
    "rec" : "REC",
    "selectCamera" : "Select Camera",
    "noCamerasFound" : "No cameras found",
    "cameraPermissionNeeded" : "Camera permission needed",
    "leave" : "Leave",
    "chooseMicCam" : "Choose Mic/Cam",
    "selectMicrophone" : "Select Microphone",
    "selectSpeaker" : "Select Speaker",
    "noMicrophonesFound" : "No microphones found",
    "noSpeakersFound" : "No speakers found",
    "microphonePermissionNeeded" : "Microphone permission needed",
    "speakerPermissionNeeded" : "Speaker permission needed",
    "noParticipantOpenCamOrMic" : "This meeting wasn’t recorded as no participants enabled their mic or camera. Recordings are only created when at least one participant interacts."
  }
}
